import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { createPortal } from 'react-dom';
import Box from '@rexlabs/box';
import { useStyles, useToken, StyleSheet, padding, border } from '@rexlabs/styling';
import { TransitionSingle } from '@rexlabs/animation';
import { Overlay } from '@rexlabs/overlay';
import { PrimaryButton, OutlineButton } from '@rexlabs/button';
import { useSelect } from '../hooks/use-select';
var defaultStyles = StyleSheet({
  overlay: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: function backgroundColor(_ref) {
      var token = _ref.token;
      return token('select.menu.background.color', token('color.container.static.default'));
    }
  },
  buttons: _objectSpread(_objectSpread({
    width: '100%',
    gap: function gap(_ref2) {
      var token = _ref2.token;
      return token('spacing.s');
    }
  }, padding.styles({
    target: 'select.overlay.buttons',
    all: 's'
  })), border.styles({
    top: {
      width: 'thin',
      color: 'container.static.light'
    }
  })),
  button: {
    flex: 1
  }
});
export function SelectOverlay(_ref3) {
  var children = _ref3.children,
      _ref3$portalTarget = _ref3.portalTarget,
      portalTarget = _ref3$portalTarget === void 0 ? window.document.body : _ref3$portalTarget;
  var s = useStyles(defaultStyles);
  var token = useToken();

  var _useSelect = useSelect(),
      isOpen = _useSelect.isOpen,
      deselectable = _useSelect.deselectable,
      reset = _useSelect.reset,
      closeMenu = _useSelect.closeMenu;

  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(TransitionSingle, {
    show: isOpen,
    configs: ['slideUp', {
      duration: token('duration.slow'),
      easing: token('easing.smooth')
    }]
  }, /*#__PURE__*/React.createElement(Overlay, _extends({}, s('overlay'), {
    show: isOpen
  }), /*#__PURE__*/React.createElement(Box, _extends({}, s('container'), {
    flexDirection: "column"
  }), children, /*#__PURE__*/React.createElement(Box, _extends({}, s('buttons'), {
    alignItems: "center"
  }), deselectable && /*#__PURE__*/React.createElement(OutlineButton, _extends({}, s('button'), {
    onClick: function onClick() {
      reset();
    }
  }), "Clear"), /*#__PURE__*/React.createElement(PrimaryButton, _extends({}, s('button'), {
    onClick: function onClick() {
      closeMenu();
    }
  }), "Done"))))), portalTarget);
}